var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"next-prev-pagination"},[_c('a',{attrs:{"href":"#","disabled":!_vm.hasPrev || _vm.isFetching},on:{"click":function($event){return _vm.goTo('prev', $event)}}},[_vm._v("<")]),_c('a',{attrs:{"href":"#","disabled":!_vm.hasNext || _vm.isFetching},on:{"click":function($event){return _vm.goTo('next', $event)}}},[_vm._v(">")])])
}
var staticRenderFns = []

export { render, staticRenderFns }